// extracted by mini-css-extract-plugin
export default {"subheading":"SectionHeading_subheading__i+t38","ml-12":"SectionHeading_ml-12__E41SR","ml-4":"SectionHeading_ml-4__0qdux"};